import React, {useMemo, useState} from 'react';
import Header from '../../common/header';
import mapStateToProps from '../../redux/util';
import {connect} from 'react-redux';
import Styles from './index.module.scss';
import {Menu} from 'antd';
import ConfigManager from '../config/config-manager';
import DeviceManager from '../device/device-manager';
import i18next from 'i18next';
// import WithoutPermission from '../config/without-permission';
import {Redirect, Route, Switch} from 'react-router-dom';


function Privatisation(props) {
    const menus = useMemo(() => {
        return [{
            title: i18next.t('configs_manager'), route: '/privatisation/config',
        }, {
            title: i18next.t('private_devices_manager'), route: '/privatisation/device',
        }];
    }, [props.locale]);
    const [currentPage, setCurrentPage] = useState('/privatisation/config');
    return <div className={ Styles.root }>
        <Header props={ props }/>
        <div className={ Styles.container }>
            <div className={ Styles.leftItem }>
                <div className={ Styles.title }>{ i18next.t('privatisation') }</div>
                <Menu
                    inlineIndent={ 0 }
                    selectedKeys={ [currentPage] }
                    mode={ 'inline' }
                    inlineCollapsed={ false }
                    theme="dark">
                    { menus.map((item, index) => {
                        return (<Menu.Item key={ item.route } onClick={ () => {
                            setCurrentPage(item.route);
                            props.history.push({
                                pathname: item.route,
                            });
                        } }>
                            <span>{ item.title }</span>
                        </Menu.Item>);
                    }) }
                </Menu>
            </div>
            <div className={ Styles.rightItem }>
                <Switch>
                    <Route path={ '/privatisation/config' } exact component={ ConfigManager }/>
                    <Route path={ '/privatisation/device' } component={ DeviceManager }/>
                    {/* <Route path={ '/privatisation/permission' } component={ WithoutPermission }/> */}
                    <Redirect to="/privatisation/config"/>
                </Switch>
            </div>
        </div>
    </div>;
}


export default connect(mapStateToProps)(Privatisation);

